import styled from 'styled-components';
import {MAIN_COLOR} from "../../../components/globalThemes";

export const StyledCard = styled.div`
    width: 270px;
    height: 430px;
    background: #ddd;
    clip-path: path('M265.3 53.9a33.3 33.3 0 0 1-17.8-5.5 32 32 0 0 1-13.7-22.9c-.2-1.1-.4-2.3-.4-3.4 0-1.3-1-1.5-1.8-1.9a163 163 0 0 0-31-11.6A257.3 257.3 0 0 0 133.7 0a254.9 254.9 0 0 0-67.1 8.7 170 170 0 0 0-31 11.6c-.8.4-1.8.6-1.8 1.9 0 1.1-.2 2.3-.4 3.4a32.4 32.4 0 0 1-13.7 22.9A33.8 33.8 0 0 1 2 53.9c-1.5.1-2.1.4-2 2v293.9c0 3.3 0 6.6.4 9.9a22 22 0 0 0 7.9 14.4c3.8 3.2 8.3 5.3 13 6.8 12.4 3.9 24.8 7.5 37.2 11.5a388.7 388.7 0 0 1 50 19.4 88.7 88.7 0 0 1 25 15.5v.1-.1c7.2-7 16.1-11.3 25-15.5a427 427 0 0 1 50-19.4l37.2-11.5c4.7-1.5 9.1-3.5 13-6.8 4.5-3.8 7.2-8.5 7.9-14.4.4-3.3.4-6.6.4-9.9V231.6 60.5v-4.6c.4-1.6-.3-1.9-1.7-2z');
    cursor: pointer;
    display: flex;
    flex-direction: column;
    margin: 30px;
    
    &:hover {
        transform: scale(1.1);
    }
    
    @media (max-width: 310px) {
        margin: 15px;
        transform: scale(0.8);   
        
        &:hover {
            transform: scale(0.9);
        }
    }
`;

export const PlayerImage = styled.img`
    color: white;
    position: absolute;
    width: 150px;
    height: 150px;
    right: 0;
    bottom: 0;
    z-index: 1;
`;

export const CardTop = styled.div`
    position: relative;
    background-color: #fdeaa7;
    overflow: hidden;
    flex: 1;
`;

export const PlayerPosition = styled.div`
    background-color: ${({position}) => position === 'goalkeeper' ? 'orange' : position === 'defender' ? '#00BFFF' : position === 'midfielder' ? '#FFFF00' : '#FF0000'};
    border-radius: 50%;
    width: 30px;
    height: 30px;
    position: absolute;
    border: 1px solid black;
    top: 60px;
    left: 10px;
    text-align: center;
    line-height: 30px;
    font-size: 12px;
    font-family: BlenderProBold, serif;
`;

export const PlayerAge = styled.p`
    width: 30px;
    height: 25px;
    position: absolute;
    top: 80px;
    left: 10px;
    text-align: center;
    line-height: 25px;
    font-size: 16px;
    font-family: Caveat, serif;
    font-weight: bold;
    border-bottom: 1px solid black;
`;

export const PlayerNationality = styled.img`
    width: 20px;
    height: 13px;
    position: absolute;
    left: 15px;
    top: 135px;
`;

export const CardBottom = styled.div`
    background: linear-gradient(to bottom, #4c4f4c, black);
    flex: 1;
`;

export const PlayerTitle = styled.p`
    font-size: 16px;
    font-family: BlenderProBold, serif;
    color: #302828;
    text-transform: uppercase;
    background-color: ${MAIN_COLOR};
    border-top: 2px solid black;
    border-bottom: 2px solid black;
    margin: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    padding-top: 3px;
    padding-bottom: 3px;
`;

export const PlayerStatsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 25px;
`;

export const PlayerStat = styled.p`
    font-size: 16px;
    font-family: BlenderProBold, serif;
    color: white;
    margin: 5px;
    text-align: center;
    margin-top: 15px;
`;

export const StatBox = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Line = styled.div`
    background-color: #808080;
    width: 1px;
    height: 120px;
    margin-top: -5px;
`;

export const IconStatWrapper = styled.div` 
    display: flex; 
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
`;

export const StatNumber = styled.p`
    color: #808080;
    font-size: 30px;
    margin-left: 10px;
    font-family: BlenderProBold, serif;
`;
